import React, { useEffect } from 'react';
import { X, Key } from 'lucide-react';
import TrocarSenhaForm from './TrocarSenhaForm';
import { User } from '../types';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';

interface TrocarSenhaModalProps {
  currentUser: User | null;
  trocaObrigatoria?: boolean;
  onClose: () => void;
  onLogout?: () => void; // Callback para notificar sobre logout
}

export const TrocarSenhaModal: React.FC<TrocarSenhaModalProps> = ({ currentUser, trocaObrigatoria = false, onClose, onLogout }) => {
  const { t } = useLanguage();
  const { theme } = useTheme();
  
  // Bloquear scroll do corpo quando o modal estiver aberto
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  if (!currentUser) {
    return null;
  }

  const handleSuccess = () => {
    // Close modal after successful password change
    setTimeout(() => {
      onClose();
    }, 2000);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-1 sm:p-4">
      <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} rounded-lg shadow-xl max-w-md w-full`}>
        <div className={`flex items-center justify-between p-3 sm:p-6 border-b ${theme === 'dark' ? 'border-gray-700' : 'border-gray-200'}`}>
          <h2 className={`text-xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'} flex items-center space-x-2`}>
            <Key className="w-6 h-6 text-purple-600" />
            <span>{t('app.changePassword')}</span>
          </h2>
          {/* {|INICIO| 22/07/2026 às 22:50 - ETAPA 7: IMPEDIR FECHAMENTO DO MODAL QUANDO A TROCA DE SENHA FOR OBRIGATORIA} */}
          {!trocaObrigatoria && (
            <button
              onClick={onClose}
              className={`${theme === 'dark' ? 'text-gray-400 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600'} transition-colors`}
            >
              <X className="w-6 h-6" />
            </button>
          )}
          {/* {|FIM| 22/07/2026 às 22:50 - ETAPA 7: IMPEDIR FECHAMENTO DO MODAL QUANDO A TROCA DE SENHA FOR OBRIGATORIA} */}
        </div>

        <div className="p-3 sm:p-6">
          {/* {|INICIO| 22/07/2026 às 22:50 - ETAPA 7: EXIBIR AVISO EXPLICITO DE TROCA OBRIGATORIA} */}
          {trocaObrigatoria && (
            <div className={`${theme === 'dark' ? 'bg-amber-900/20 border-amber-700 text-amber-200' : 'bg-amber-50 border-amber-200 text-amber-800'} mb-4 rounded-lg border p-3 text-sm`}>
              {t('auth.passwordChangeRequiredNotice')}
            </div>
          )}
          {/* {|FIM| 22/07/2026 às 22:50 - ETAPA 7: EXIBIR AVISO EXPLICITO DE TROCA OBRIGATORIA} */}
          <TrocarSenhaForm
            idcliente={currentUser.idcliente}
            onSuccess={handleSuccess}
            onError={(message) => {
              console.error('Erro ao trocar senha:', message);
            }}
            onLogout={onLogout}
          />
        </div>
      </div>
    </div>
  );
};
